/**
 * BotSpot Web Dashboard Authentication Hook
 *
 * Custom hook to access authentication context.
 */

import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

/**
 * Use Authentication Hook
 *
 * Provides access to authentication state and methods.
 *
 * @throws Error if used outside AuthProvider
 * @returns Authentication context state
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
